export const API_ENDPOINTS = {
    OneDeskLogin: "/OneDesk/login",
    getHotelList: "/hotel/hotelList",
    insertHotel: "/hotel/insertHotel",
    updateHotelList: "/hotel/update",
    adminUpdatePassword: "/OneDesk/reset-password",
    AddAdmin: "/OneDesk/create",
    adminList: "/OneDesk/AdminList",
    createRole: "/OneDesk/CreateRole",
    roleList: "/OneDesk/RoleList",
    updateRole: "/OneDesk/UpdateRole",
    uploadImage: "/fileUpload/uploadImage",
    getDashboardData: "/OneDesk/dashboard",
    adminListById: "OneDesk/adminByID",
    AddChannelManager: "channelPartner/insert",
    channelList: "channelPartner/list",
    UpdateChannelManager: "channelPartner/update",
    subscriptionPlanList: "subscriptionPlan/getPlans",
    insertSubscription: "subscriptionPlan/insertPlan",
    updateSubscriptionPlan: "subscriptionPlan/updatePlan"
};
